import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { PrintoutTemplateApi } from "../../../../../../../../../../services/Api/Organization/types";
import PrintoutTemplateForm from "../../components/PrintoutTemplateForm";

const OrganizationSettingsPrintoutTemplatesNewPage = (): JSX.Element => {
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(t("modules.printout_template.header.new.title"));
	}, []);

	return (
		<>
			<Header title={t("modules.printout_template.header.new.title")} />
			<PrintoutTemplateForm
				printoutTemplate={
					{
						text_size: "SMALL",
						items_sort: "ALPHABETICAL",
						kitchen_order_printing_type: "ASYNC_AFTER_ORDER_CLOSE",
					} as PrintoutTemplateApi
				}
			/>
		</>
	);
};

export default OrganizationSettingsPrintoutTemplatesNewPage;
